module.exports = __webpack_public_path__ + "static/cover2-5bbff2f3bdc8a2e39024a1b660dff02a.png";